module.exports = __webpack_public_path__ + "img/graph_c.8eb825b9.svg";